// Application Constants
export const APP_CONFIG = {
  NAME: "R11 Web",
  VERSION: "1.0.0",
  DESCRIPTION: "E-commerce platform for R11",
};

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
  CART: "/cart",
  CHECKOUT: "/checkout",
  PRODUCT: "/product/:retailer/:productId",
  ADMIN: "/admin",
  SHOPPER: "/shopper",
  CARGO: "/cargo",
  UNAUTHORIZED: "/unauthorized",
};

export const USER_ROLES = {
  CUSTOMER: "customer",
  ADMIN: "admin",
  SHOPPER: "shopper",
  CARGO: "cargo",
} as const;

export const CURRENCY = {
  DEFAULT: "USD",
  SYMBOL: "$",
  DECIMAL_PLACES: 2,
};

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 12,
  MAX_PAGE_SIZE: 100,
};

export const VALIDATION = {
  PASSWORD_MIN_LENGTH: 8,
  PHONE_REGEX: /^\+?[\d\s\-\(\)]+$/,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};

export const STORAGE_KEYS = {
  AUTH_TOKEN: "auth_token",
  USER_DATA: "user_data",
  CART_DATA: "cart_data",
  THEME: "theme",
  LANGUAGE: "language",
};

export const SHIPPING = {
  /** Minimum shipping fee in USD - orders with lower shipping will be charged this amount */
  MINIMUM_FEE: 5.1,
  /** Weekly US→TJK flight day. Used by the ShippingInfoCard. Keep in sync with locale `shipping.*` strings. */
  FLIGHT_DAY: "Wednesday",
  /** Base rate per kg for weight-based items. */
  RATE_PER_KG_USD: 16,
  /**
   * Reference pricing table for the Pricing tab of the ShippingInfoCard.
   * `id` keys map to translation labels at `shipping.pricing.<id>` and icons in the component.
   * Order in the array == display order.
   */
  PRICING_TABLE: [
    { id: "macbook", price: 80 },
    { id: "laptopUnder4kg", price: 80 },
    { id: "laptopOver4kg", price: 80, perKg: 16 },
    { id: "iphone", price: 80 },
    { id: "ipad", price: 50 },
    { id: "appleWatch", price: 25 },
    { id: "airpods", price: 20 },
    { id: "metaGlasses", price: 20 },
    { id: "kindles", price: 15 },
  ] as ReadonlyArray<{ id: string; price: number; perKg?: number }>,
};
